module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAZlBMVEUAAABAQEAzMzMwMDA2NjY3Nzc1NTU0NDQzMzMxMTEyMjI0NDQ0NDQzMzMzMzMyMjI0NDQyMjI0NDQzMzMzMzMzMzMzMzMzMzMyMjI0NDQzMzMzMzMzMzMzMzMzMzMzMzMzMzP///988VbMAAAAIHRSTlMABAUQExcwMTI5SF1ebXKEhZOUmpu0tb/Awc3e4+719hhgJ2YAAAABYktHRCHEbA0WAAAAY0lEQVQY073IWQJAIABF0SfzlHmO7H+VhCj5dv/uQTsbNahXowpkeFtPAJfpxlzsBVw17uMoVjHGVflYIQ2kk9ZZN8KZTpscKHmLsMWDVi4w0w1UIP0L0w9sbAN5gnfRGD6zAQ9YFePY37k4AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/Images/filter.png
// module id = hx9e
// module chunks = 1